
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.664 12.476c0 .916-.75 1.667-1.668 1.667-.917 0-1.667-.75-1.667-1.668 0-.916.75-1.667 1.667-1.667s1.668.75 1.668 1.668zM9.637 8.349a1.243 1.243 0 00-1.767 0 5.842 5.842 0 000 8.253c.242.242.567.367.884.367.316 0 .641-.125.883-.367a1.243 1.243 0 000-1.767 3.34 3.34 0 010-4.719 1.243 1.243 0 000-1.767zm6.486 0a1.243 1.243 0 00-1.768 0 1.25 1.25 0 000 1.767c.634.634.976 1.468.976 2.36 0 .891-.35 1.725-.976 2.359a1.243 1.243 0 000 1.767c.242.242.567.367.884.367.317 0 .642-.125.884-.367a5.801 5.801 0 001.709-4.127 5.802 5.802 0 00-1.71-4.126zM6.694 7.174a1.243 1.243 0 000-1.768 1.243 1.243 0 00-1.767 0C1.026 9.3 1.026 15.652 4.92 19.553c.242.242.567.367.883.367.317 0 .642-.125.884-.367a1.243 1.243 0 000-1.767C3.76 14.86 3.76 10.1 6.686 7.174h.008zm12.38-1.768a1.243 1.243 0 00-1.767 0 1.243 1.243 0 000 1.768c2.926 2.926 2.926 7.686 0 10.612a1.243 1.243 0 000 1.767c.241.242.567.367.883.367.317 0 .642-.125.884-.367 3.901-3.901 3.901-10.245 0-14.147z"}})])
          )
        }
      }
    